import { PLAY_PIP_MEDIA } from '../actions/playmedia';
import { HIDE_PIP_MEDIA } from '../actions/playmedia';
import { REPLACE_PIP_SOURCE_MEDIA } from '../actions/playmedia';

const initialState = {
  // Define this player as pip, when we do the first load of the app
  isPip: true
};

function reducer(state = initialState, action) {

  switch (action.type) {

    case PLAY_PIP_MEDIA:
    return action.playerProps;
      //return { ...state, ...action.playerProps };

    case HIDE_PIP_MEDIA:
      return initialState;

    case REPLACE_PIP_SOURCE_MEDIA:
      return { ...state, newSource: action.newSource };

    default:
      return state;
  }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/playerpip.js